import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import CartItemDetail from '../../components/ItemBuilder/menu/CartItemDetail';
import { selectCartItems } from '../../selectors/cart';
import { selectSelectedItemCartId } from '../../selectors/dialog';
import { SetCartItemRef } from '../../types';
import { useAppSelector } from '../../app/hooks';
import { selectAutoComboCartItems } from '../../redux/features/autoCombo/autoCombo.selector';
import { isValidCartSelector } from '../../utils/cart';
import useAutoCombo from '../../hooks/autoCombo/useAutoCombo.hooks';

const useStyles = makeStyles(({ spacing }: Theme) => ({
  conatiner: {
    padding: `${spacing(7)} ${spacing(1)} 0 ${spacing(1)}`,
  },
  title: {
    fontStyle: 'italic',
  },
}));

interface OwnProps {
  setCartItemRef: SetCartItemRef;
}

const ItemBuilder = memo(function (props: OwnProps) {
  const { setCartItemRef } = props;
  const classes = useStyles(props);

  const cartItems = useSelector(selectCartItems);
  const selectedItemCartId = useSelector(selectSelectedItemCartId);
  const validCart = useSelector(isValidCartSelector);
  const autoCombinedCartItems = useAppSelector(selectAutoComboCartItems);

  const { isAutoComboEnabled } = useAutoCombo();

  const cartItem =
    validCart &&
    isAutoComboEnabled &&
    Object.values(autoCombinedCartItems).length
      ? autoCombinedCartItems[selectedItemCartId]
      : cartItems?.[selectedItemCartId];

  return (
    // HITL-1530: `data-alt-readout-scope` marks this subtree as the only place
    // Alt+click reads a label out. The center pane is where the menu lives —
    // sizes, options, modifier choices — so it is the only pane whose labels
    // answer a customer's question. The cart, the action bar and the header
    // carry controls that act rather than inform, and stay untouched.
    <div id="itemBuilder" className={classes.conatiner} data-alt-readout-scope>
      {selectedItemCartId && cartItem && !cartItem.autoCombinedCartItemIds ? (
        <CartItemDetail cartItem={cartItem} setCartItemRef={setCartItemRef} />
      ) : undefined}
    </div>
  );
});

export default ItemBuilder;
